import React from 'react';
import { Image } from '@chakra-ui/image';
import { Box, Flex } from '@chakra-ui/layout';
import moment from 'moment';

import TokenImage from './TokenImage';
import { isNull } from '../utils/core';
import DataGrid from './DataGrid';
import Text from './Text';

const columns = [
  {
    label: 'Token',
    dataKey: 'token',
    renderCell: ({
      token = {},
      token: {
        address = 'Unknown',
        label = address,
        ercType,
        ercTypeLabel,
        symbol,
        tokenId,
        units: value,
      },
      isMobile,
    }) => (
      <Flex justifyContent="left" alignItems="center" height="100%" padding={isMobile ? 0 : '20px'}>
        <TokenImage boxSize={isMobile ? '20px' : '40px'} token={token} />
        <Box d="block" ml="15">
          {
            ercType === 1155 ? (
              <Flex alignItems="baseline">
                <Text textStyle="h4" as="h4" d="flex" alignItems="baseline" title={address}>
                  {`Token ${tokenId}${value > 0 ? ` (${value})` : ''}`}
                </Text>
              </Flex>
            ) : (
              <Flex alignItems="baseline">
                <Text textStyle="body">
                  {`${isNull(value) ? '' : `${parseFloat(value).toString()} `}${symbol}`}
                </Text>
                {!ercTypeLabel ? null : <Text ml="3px" textStyle="small">{`(${ercTypeLabel})`}</Text>}
              </Flex>
            )
          }
          <Text
            textStyle="small"
            title={address}
            style={{
              maxWidth: '12em',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {label === 'Unknown' || ercType === 1155 ? address : label}
          </Text>
        </Box>
      </Flex>
    ),
    span: 3,
  },
  {
    label: 'Status',
    dataKey: 'status',
    renderCell: ({ status = '' }) => (
      <Flex height="100%" alignItems="center">
        <Box
          bgColor={status === 'success' ? 'successGreen' : 'errorRed'}
          pt="2px"
          pb="1px"
          px="5px"
          borderRadius="2px"
        >
          <Text textStyle="small2" style={{ color: 'white' }}>
            {`${status}`.toUpperCase()}
          </Text>
        </Box>
      </Flex>
    ),
    span: 2,
  },
  {
    label: 'Origin',
    dataKey: 'origin',
    renderCell: ({ origin: { name, img } }) => (
      <Flex justifyContent="left" alignItems="center" height="100%">
        <Image boxSize="20px" mr="5px" src={img} />
        <Text textStyle="bodyGrey2" color="grey700">
          {name}
        </Text>
      </Flex>
    ),
    span: 2,
  },
  {
    label: 'Destination',
    dataKey: 'destination',
    renderCell: ({ destination: { name, img } }) => (
      <Flex justifyContent="left" alignItems="center" height="100%">
        <Image boxSize="20px" mr="5px" src={img} />
        <Text textStyle="bodyGrey2" color="grey700">
          {name}
        </Text>
      </Flex>
    ),
    span: 2,
  },
  {
    label: 'Duration',
    dataKey: 'duration',
    renderCell: ({ completed, duration = 'Not currently available' }) => (
      <Flex justifyContent="left" alignItems="center" height="100%">
        <Text textStyle="bodyGrey2" color="grey700">
          { typeof duration === 'string'
            ? duration
            : moment(completed).subtract(duration, 'milliseconds').fromNow(true)}
        </Text>
      </Flex>
    ),
    span: 2,
  },
  {
    label: 'Date/Time',
    dataKey: 'started',
    renderCell: ({ started }) => (
      <Flex justifyContent="left" alignItems="center" height="100%">
        <Text textStyle="bodyGrey2" color="grey700">
          {started.format('MMM D, YYYY, HH:mm')}
        </Text>
      </Flex>
    ),
    span: 2,
  },
];

const TransferHistoryTable = ({
  transfers = [],
  emptyState = () => 'No completed transfers available',
  ...props
}) => {
  return (
    <DataGrid
      columns={columns}
      data={transfers}
      idKey="depositKey"
      emptyState={emptyState}
      {...props}
    />
  );
};

export default TransferHistoryTable;
